<h2 style="color: #004F71">Alternate Variations</h2>
<ng-container *ngIf="groupedVariations.length; else noOverrides">
    <mat-accordion [multi]="true">
        <mat-expansion-panel *ngFor="let group of groupedVariations; trackBy: trackByVariation" [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ group.variationLabel }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <table mat-table [dataSource]="group.rows" style="width: 100%;">
                <ng-container matColumnDef="attribute">
                    <th mat-header-cell *matHeaderCellDef><b>Attribute</b></th>
                    <td mat-cell *matCellDef="let row">{{ row.attribute }}</td>
                </ng-container>

                <ng-container matColumnDef="baseValue">
                    <th mat-header-cell *matHeaderCellDef><b>Base Value</b></th>
                    <td mat-cell *matCellDef="let row">{{ row.baseValue }}</td>
                </ng-container>

                <ng-container matColumnDef="override">
                    <th mat-header-cell *matHeaderCellDef><b>Modified Value</b></th>
                    <td mat-cell *matCellDef="let row">{{ row.override }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['attribute', 'baseValue', 'override']; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: ['attribute', 'baseValue', 'override'];"></tr>
            </table>
        </mat-expansion-panel>
    </mat-accordion>
</ng-container>
<ng-template #noOverrides>
    <p>There are no overrides to display</p>
</ng-template>
